import React from "react";
import { View, Text, TouchableOpacity, Image, Dimensions } from "react-native";

import { LinearGradient } from "expo-linear-gradient";
import { StatusBar } from "expo-status-bar";
import Logo from "../../../assets/logotipo-branco.png"
import styles from "./style";

export default function Welcome({ navigation }) {

  function handlePressedButton(route) {
    navigation.navigate(route);
  }

  return (
    <View style={styles.container}>
      <LinearGradient
        start={{ x: -1, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={["#16576E", "#199991"]}
        style={{ width: "100%", alignItems: "center", flex: 1 }}
      >
        <Image style={{ width: 230, height: 133, marginVertical: "10%" }} source={Logo} />
        <View style={styles.loginContainer}>
          <TouchableOpacity onPress={() => handlePressedButton("Register")}>
            <LinearGradient
              start={{ x: -1, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={["#16576E", "#199991"]}
              style={styles.button}
            >
              <Text style={[styles.text, { color: "#FFF" }]}>Criar Conta</Text>
            </LinearGradient>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => handlePressedButton("Login")}
            style={[styles.button, styles.loginButton]}
          >
            <Image source={Logo} />
            <Text style={[styles.text, { color: "#1FBFB5" }]}>Entrar</Text>
          </TouchableOpacity>
        </View>

        <StatusBar style="light"></StatusBar>
      </LinearGradient>
    </View>
  );
}
